/* eslint max-len: 0 */
import { MeRepository, DevicesRepository, LicensesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { AppInstancesProcessor, DevicesProcessor } from 'common/repositoryProcessors/index';

/**
 * Devices controller
 */
angular.module('controllers')
    .controller(
        'Devices',
        (
            $scope, $state, $stateParams, $window,
            Auth, Util, $rootScope,
        ) => {

            const userId = MeRepository.getMyId();
            $scope.brandName = CWCONFIG.partnerConfig.name;

            if ($stateParams.deploy) {

                // if 'deploy' query param is present, open the deploy modal for that os
                if ($stateParams.deploy === 'apps') {

                    $state.go(
                        'root.dashboard.devices.ltb.deploy',
                        {
                            ltb: 'deploy',
                            resourceId: 'new',
                            os: Util.getDeviceNavigator(),
                        }, {
                            reload: false,
                            inherit: false,
                        },
                    );

                } else {

                    /**
                     * no condition is set for the current value of the 'deploy' query param so
                     * reload the devices page removing the 'deploy' param from the url
                     *
                     * Note:
                     * if the unknown param is left in the url, the deployment modals
                     * will not work properly
                     */
                    $state.go('root.dashboard.devices', {}, {
                        inherit: false,
                    });

                }

            }

            /**
            * Set static values for deviceCategory for Add Device button
            * They are linked to the DeviceCardDirective by sending category like: <device-card category="desktop"></device-card>
            * Do not change them! The function $scope.deployOnCategory will fail with other config.
            */
            $scope.desktop = 'desktop';
            $scope.mobile = 'mobile';

            /**
         * For each received device - calculates if it has antivirus installed or not
         * @param devices
         */
            const updateHasAvInstance = (devices) => {

                devices.forEach((device) => {

                    device.attributes.hasAv =
                        DevicesProcessor.hasAvInstalled(
                            device.relationships.user.data.id,
                            device.id,
                        );

                });

                return devices;

            };

            function calculateDevicesStatus() {

                $scope.onlineDevices = updateHasAvInstance(DevicesRepository.getByState(['online']) || []);
                $scope.offlineDevices = updateHasAvInstance(DevicesRepository.getByState(['offline']) || []);
                $scope.hasDevices = DevicesProcessor.hasDisplayedDevices();
                $scope.hasMobileDevices = DevicesProcessor.hasAtLeastOnePhoneOrTablet();
                $scope.hasDesktopDevices = DevicesProcessor.hasAtLeastOneLaptopOrPc();

                $scope.onlineDesktopDevices = $scope.onlineDevices.filter(device => device.attributes.type === 'pc' || device.attributes.type === 'laptop');
                $scope.onlineMobileDevices = $scope.onlineDevices.filter(device => device.attributes.type === 'phone' || device.attributes.type === 'tablet');

                $scope.offlineDesktopDevices = $scope.offlineDevices.filter(device => device.attributes.type === 'pc' || device.attributes.type === 'laptop');
                $scope.offlineMobileDevices = $scope.offlineDevices.filter(device => device.attributes.type === 'phone' || device.attributes.type === 'tablet');

                // update devices with licenses info
                $scope.onlineDevices = DevicesProcessor.detectLicenseType($scope.onlineDevices);
                $scope.offlineDevices = DevicesProcessor.detectLicenseType($scope.offlineDevices);
                $scope.onlineDesktopDevices = DevicesProcessor.detectLicenseType($scope.onlineDesktopDevices);
                $scope.onlineMobileDevices = DevicesProcessor.detectLicenseType($scope.onlineMobileDevices);
                $scope.offlineDesktopDevices = DevicesProcessor.detectLicenseType($scope.offlineDesktopDevices);
                $scope.offlineMobileDevices = DevicesProcessor.detectLicenseType($scope.offlineMobileDevices);

                // check if the account has a minimum of 5 devices
                const visibleDevices = DevicesRepository.getVisibleDevices();
                $scope.hasMinimumDevices = (Object.keys(visibleDevices).length >= 5);

            }

            const devicesLength = DevicesRepository.getAll().length;

            // direct binding for devices
            const devicesObservable = DevicesRepository.getObservable();
            const onNextDevice = (data) => {

                calculateDevicesStatus();

                if (data.length !== devicesLength) {

                    $rootScope.showPendingInstallCard = false;

                }

            };
            const devicesSubscriber =
                devicesObservable.subscribe(onNextDevice, () => { }, () => { });


            // direct binding for licenses
            const licensesObservable = LicensesRepository.getObservable();
            const onNextLicense = () => {

                calculateDevicesStatus();

            };
            const licensesSubscriber =
                licensesObservable.subscribe(onNextLicense, () => { }, () => { });

            // direct binding for instances
            const instancesObservable = AppInstancesProcessor.getObservable();
            const onNextInstance = (data) => {

                $scope.instances = data[userId];
                calculateDevicesStatus();

            };
            const instancesSubscriber =
                instancesObservable.subscribe(onNextInstance, () => { }, () => { });

            $scope.deployOn = (deviceType) => {

                $state.go('root.ltb.devicetype', {
                    ltb: 'deploy',
                    deviceType,
                });

            };

            $scope.deployOnCategory = (category) => {

                $state.go('root.dashboard.devices.ltb.deploy', {
                    ltb: 'deploy',
                    resourceId: 'new',
                    deviceCategory: category,
                }, {
                    reload: false,
                });

            };

            $scope.mixpanelBannerClick = () => {

                Mixpanel.send('ConnectWeb Devices Mobile Banner Click', {
                    View: $scope.devicesView,
                });

            };

            if (!localStorage.getItem('DevicesView') || ((localStorage.getItem('DevicesView') === 'list') && !$scope.hasMinimumDevices)) {

                localStorage.setItem('DevicesView', 'grid');

            }

            $scope.devicesView = localStorage.getItem('DevicesView');

            Mixpanel.send('ConnectWeb Devices Open', {
                Source: Auth.loginSource || 'Direct',
                View: $scope.devicesView,
            });

            // Calculate which banner should be displayed
            const offerLocalStorageName = Util.deepFind(CWCONFIG, 'features.offerBanner.localStorageName');
            const welcomeOfferWasClosed = localStorage.getItem(offerLocalStorageName) === null ? true : localStorage.getItem(offerLocalStorageName);

            if (!welcomeOfferWasClosed && $scope.devicesView === 'grid' && $scope.hasDevices && !$scope.hasMobileDevices) {

                const decidingValue = Math.floor(Math.random() * 2);

                $scope.displayBanner = (decidingValue === 0) ? 'welcome-offer' : 'mobile';

            } else if ($scope.devicesView === 'list' || !$scope.hasDevices || $scope.hasMobileDevices) {

                $scope.displayBanner = 'welcome-offer';

            } else {

                $scope.displayBanner = 'mobile';

            }

            // Save a copy of the calculation to use it afterwards
            const bannerValue = $scope.displayBanner;

            $scope.gridView = () => {

                $scope.devicesView = 'grid';
                localStorage.setItem('DevicesView', $scope.devicesView);

                if (!welcomeOfferWasClosed) {

                    $scope.displayBanner = bannerValue;

                } else if (!$scope.hasMobileDevices) {

                    $scope.displayBanner = 'mobile';

                }

                Mixpanel.send('ConnectWeb Devices View Click', {
                    View: $scope.devicesView,
                });

            };

            $scope.listView = () => {

                $scope.devicesView = 'list';
                localStorage.setItem('DevicesView', $scope.devicesView);

                $scope.displayBanner = 'welcome-offer';

                Mixpanel.send('ConnectWeb Devices View Click', {
                    View: $scope.devicesView,
                });

            };

            $scope.$on('$destroy', () => {

                devicesSubscriber.dispose();
                instancesSubscriber.dispose();
                licensesSubscriber.dispose();

            });

            if (!$rootScope.hasUsCompliance) {

                $rootScope.showCmaDisclaimer.banner = false;

            }

            if ($scope.displayBanner === 'mobile') {

                $rootScope.showCmaDisclaimer.banner = false;

            }

        },
    );



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/devices/devices.js